import type {Me} from '@briary/shared'

/** Restrict only the two owner pages, including their detail paths. */
export function canOpenSensitiveMoneyPath(me:Pick<Me,'isSuperadmin'>|null,path:string):boolean {
  // matchPath also collapses repeated slashes, so make the same comparison.
  const normalized='/'+path.split('/').filter(Boolean).join('/')
  const ownerOnly=['/admin/money/settings','/admin/money/scoro-history'].some(root=>normalized===root||normalized.startsWith(root+'/'))
  return !ownerOnly||me?.isSuperadmin===true
}
